import {Component} from '@angular/core';
import { NavigationComponent } from '../../shared/components/navigation/navigation.component';
import { RouterOutlet } from '@angular/router';
import { RightDrawerComponent } from '../right-drawer/right-drawer.component';

@Component({
  selector: 'app-dashboard-layout',
  templateUrl: './dashboard-layout.component.html',
  styleUrls: ['./dashboard-layout.component.scss'],
  imports: [NavigationComponent, RouterOutlet, RightDrawerComponent],
})
export class DashboardLayoutComponent {}
